import { useMutation } from '@apollo/client';
import {
  CREATE_PARTNER_REQUEST,
  UPDATE_PARTNER_REQUEST,
} from 'graphql/secure/mutations/partner.mutations';
import {
  IUpdatePartnerRequest,
  IPartnerRequest,
  TRequestType,
  EPartnerRequestStatus,
} from 'FeatureModules/Partner/types/partner.types';
import useDialog from 'hooks/useDialog';

const usePartnerRequestActions = () => {
  const { openDialog } = useDialog();
  const [createPartnerRequest, { loading: createLoading }] = useMutation<
    { createPartnerRequest: { partnerRequest: IPartnerRequest } },
    {
      input: {
        requestTitle: string;
        requestMessage: string;
        requestedToCompanyId: string;
        requestType: TRequestType;
        componentId?: string;
      };
    }
  >(CREATE_PARTNER_REQUEST);

  const [updatePartnerRequest, { loading: updateLoading }] = useMutation<
    { updatePartnerRequest: IUpdatePartnerRequest },
    {
      id: IPartnerRequest['id'];
      input: {
        requestStatus?: IPartnerRequest['requestStatus'];
        documentId?: IPartnerRequest['documentId'];
        selfAssessmentId?: string;
        requestReplyMessage?: IPartnerRequest['requestReplyMessage'];
        requestMessage?: IPartnerRequest['requestMessage'];
      };
    }
  >(UPDATE_PARTNER_REQUEST);

  const deletePartnerRequest = (id: IPartnerRequest['id']) => {
    updatePartnerRequest({
      variables: { id, input: { requestStatus: EPartnerRequestStatus.DELETED } },
    });
  };

  const handleDeletePartnerRequest = (id: IPartnerRequest['id']) => {
    openDialog({
      type: 'ALERT',
      props: {
        displayCloseButton: true,
        title: 'Delete partner request',
        submitText: 'Delete',
        text: 'Are you sure you want to delete this partner request? You will not be able to restore it.',
        onCancel: () => undefined,
        onSubmit: () => deletePartnerRequest(id),
      },
    });
  };

  return {
    createPartnerRequest,
    updatePartnerRequest,
    deletePartnerRequest,
    handleDeletePartnerRequest,
    loading: createLoading || updateLoading,
  };
};

export default usePartnerRequestActions;
